/* ================================
  Cart Drawer
================================ */

class CartDrawer extends HTMLElement {
  constructor() {
    super();

    // Close on Escape
    this.addEventListener('keyup', e => e.code === 'Escape' && this.close());

    // Close on overlay click
    this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));

    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');

    cartLink.addEventListener('click', e => {
      e.preventDefault();
      this.open(cartLink);
    });

    cartLink.addEventListener('keydown', e => {
      if (e.code.toUpperCase() === 'SPACE') {
        e.preventDefault();
        this.open(cartLink);
      }
    });
  }

 open(triggeredBy) {
  if (triggeredBy) this.activeElement = triggeredBy;
  this.classList.add('animate', 'active');
  document.body.classList.add('overflow-hidden');
  this.loadRecommendations();
}

close() {
  this.classList.remove('active');
  document.body.classList.remove('overflow-hidden');
}

  renderContents(parsedState) {
    this.querySelector('.drawer__inner')?.classList.remove('is-empty');

    this.getSectionsToRender().forEach(section => {
      const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (!el) return;

      // Only replace content except #cart-recommendations
      if (el.id === 'cart-recommendations') return;

      el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
    });
this.querySelector('#CartDrawer-Overlay')?.addEventListener('click', this.close.bind(this));
this.open();

// Reload recommendations after drawer update
this.loadRecommendations();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      { id: 'cart-drawer', section: 'cart-drawer', selector: '#CartDrawer' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble' }
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  loadRecommendations() {
    const container = document.getElementById('cart-recommendations');
    if (!container) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        if (!cart.items.length) {
          container.style.display = 'none';
          return;
        }
        container.style.display = 'block';
        const lastProductId = cart.items[cart.items.length - 1].product_id;
        window.loadCartDrawerRecommendations?.(lastProductId);
      });
  }
}

customElements.define('cart-drawer', CartDrawer);



/* ================================
  Cart Drawer Items
================================ */

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }

  onCartUpdate() {
    super.onCartUpdate();

    // Reload recommendations dynamically after cart changes
    const drawer = document.querySelector('cart-drawer');
    drawer?.loadRecommendations();
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ================================
  YOU MAY ALSO LIKE Recommendations
================================ */

const currencySymbol = 'AED';

function formatMoney(cents) {
  if (!cents) return '';
  return currencySymbol + (cents / 100).toFixed(2);
}

function loadCartDrawerRecommendations(productId) {
  const container = document.getElementById('cart-recommendations');
  if (!container || !productId) return;

  const track = container.querySelector('.recommendations-wrapper');
  if (!track) return;

 fetch(`/recommendations/products.json?product_id=${productId}&limit=8&t=${Date.now()}`)
    .then(res => res.json())
    .then(data => {
      if (!data.products?.length) {
        container.style.display = 'none';
        return;
      }

      container.style.display = 'block';
      track.innerHTML = '';

      data.products.forEach(product => {

        // console.log(product);
        if (!product.variants?.length) return;

        track.insertAdjacentHTML('beforeend', `
          <div class="cart-recommendation-item">
            <div class="img-container">
              <img src="${product.featured_image}" alt="${product.title}">
            </div>
            <div class="content__container">
              <a href="/products/${product.handle}">
                <p class="title">${product.title}</p>
                <p class="price">${formatMoney(product.price)}</p>
                
              </a>
            </div>
            <button class="recommendation_add_product" data-variant-id="${product.variants[0].id}"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-bag" viewBox="0 0 16 16">
  <path d="M8 1a2.5 2.5 0 0 1 2.5 2.5V4h-5v-.5A2.5 2.5 0 0 1 8 1m3.5 3v-.5a3.5 3.5 0 1 0-7 0V4H1v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4zM2 5h12v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/>
</svg></button>
          </div>
        `);
      });
    });
}

/* ================================
  Recommendation Add to Cart
================================ */
document.addEventListener('click', function (e) {

  let btn = e.target;

  // climb up manually to find button
  while (btn && !btn.classList?.contains('recommendation_add_product')) {
    btn = btn.parentElement;
  }

  if (!btn) return;

  e.preventDefault();

  // Disable the button
  btn.disabled = true;

  // Save original content
  const originalContent = btn.innerHTML;

  // Add loader (simple spinner)
  btn.innerHTML = `<span class="loader" style="
    display:inline-block;
    width:16px;
    height:16px;
    border:2px solid #fff;
    border-top-color: transparent;
    border-radius:50%;
    animation: spin 1s linear infinite;
    vertical-align: middle;
    "></span>`;

  // Add CSS for spinner animation
  if (!document.getElementById('loader-spin-style')) {
    const style = document.createElement('style');
    style.id = 'loader-spin-style';
    style.textContent = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    `;
    document.head.appendChild(style);
  }

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: btn.dataset.variantId, quantity: 1 })
  })
 .then(() => {
  window.refreshCartDrawer?.();
  btn.disabled = false;
  btn.innerHTML = originalContent;
})
  .catch(() => {
    btn.disabled = false;
    btn.innerHTML = originalContent;
  });
});

